import { createBrowserRouter, redirect } from "react-router";
import App from "./App";
import { GlobalStatsPage } from "./pages/GlobalStats/GlobalStats.page";
import { CityEscapePage } from "./pages/CityEscape/CityEscape.page";
import Dashboard from "./pages/Dashboard";
import { EnigmasPage } from "./pages/Engimas/Enigmas.page";
import { NotFoundPage } from "./pages/NotFound/NotFound.page";
import { lazy } from "react";

export type Router = ReturnType<typeof createBrowserRouter>;

// const GlobalStatsPage = lazy(
//   () => import("./pages/GlobalStats/GlobalStats.page")
// );
// const CityEscapePage = lazy(() => import("./pages/CityEscape/CityEscape.page"));
// const EnigmasPage = lazy(() => import("./pages/Engimas/Enigmas.page"));
// const NotFoundPage = lazy(() => import("./pages/NotFound/NotFound.page"));

export const ROUTER: Router = createBrowserRouter([
  {
    path: "/",
    Component: App,
    children: [
      {
        index: true,
        loader: async () => redirect("/enigmas"),
      },
      {
        path: "dashboard",
        Component: Dashboard,
      },
      {
        path: "enigmas/:cityEscapeId?/:enigmaId?",
        Component: EnigmasPage,
        index: true,
      },
      {
        path: "global-stats",
        Component: GlobalStatsPage,
        index: true,
      },
      {
        path: "city-escape/:cityEscapeId?",
        Component: CityEscapePage,
        index: true,
      },
      {
        path: "*",
        Component: NotFoundPage,
      },
    ],
  },
]);
